import React, { FC, useState } from 'react';
import { partTypeEnum } from '../models/part-type.enum';
import styles from './TowerPartSelector.module.css';

interface TowerPartSelectorProps {
    activePart: partTypeEnum,
    setActivePart: (partType: partTypeEnum) => void,
    getPartName: (partType: partTypeEnum) => string
}

const TowerPartSelector: FC<TowerPartSelectorProps> = ({ activePart, setActivePart, getPartName }) => {

    return (
        <div className={styles.TowerPartSelector} data-testid="TowerPartSelector">
              <button className={`${styles.pButton} ${styles.firstflex}`} onClick={() => setActivePart(partTypeEnum.headLeft)}>
                <div className={`${styles.head} ${styles.headLeft}`}>
                    {getPartName(partTypeEnum.headLeft)}
                </div>
                <div className={`${styles.headbox} ${activePart === partTypeEnum.headLeft ? styles.active : ''}`}></div>
            </button>
            <div className={styles.secondflex}>
                <button className={`${styles.pButton} ${styles.bodies}`} onClick={() => setActivePart(partTypeEnum.bodyA)}>
                    <div className={`${styles.bodybox} ${activePart === partTypeEnum.bodyA ? styles.active : ''}`}>
                        <div className={styles.body}>
                            {getPartName(partTypeEnum.bodyA)}
                        </div>
                    </div>
                </button>
                <button className={`${styles.pButton} ${styles.bodies}`} onClick={() => setActivePart(partTypeEnum.bodyB)}>
                    <div className={`${styles.bodybox} ${activePart === partTypeEnum.bodyB ? styles.active : ''}`}>
                        <div className={styles.body}>
                            {getPartName(partTypeEnum.bodyB)}
                        </div>
                    </div>
                </button>
            </div>
            <button className={`${styles.pButton} ${styles.thirdflex}`} onClick={() => setActivePart(partTypeEnum.headRight)}>
                <div className={`${styles.headbox} ${activePart === partTypeEnum.headRight ? styles.active : ''}`}></div>
                <div className={`${styles.head} ${styles.headRight}`}>
                    {getPartName(partTypeEnum.headRight)}
                </div>
            </button>
        </div>
    )
};

export default TowerPartSelector;
